import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "./Icon";

/**
 * Top nav shared by all marketing-facing pages (landing, FAQ, eventually
 * any other public route). One place to keep the logo + nav links + login
 * CTA consistent so /faq doesn't drift from /.
 *
 * Features / How it works link back to the landing's section anchors.
 */

interface MarketingHeaderProps {
  onLogin: () => void;
}

const PURPLE = "#9146FF";
const CYAN = "#00D4FF";
const TEXT = "#e2e8f0";
const MUTED = "#a0aec0";

const gradientText: React.CSSProperties = {
  background: `linear-gradient(135deg, ${PURPLE} 0%, ${CYAN} 100%)`,
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  backgroundClip: "text",
};

const primaryButton: React.CSSProperties = {
  background: `linear-gradient(135deg, ${PURPLE} 0%, ${CYAN} 100%)`,
  color: "white",
  border: "none",
  padding: "14px 28px",
  fontSize: "16px",
  fontWeight: 600,
  borderRadius: "12px",
  cursor: "pointer",
  boxShadow: "0 8px 25px rgba(145, 70, 255, 0.4)",
  display: "inline-flex",
  alignItems: "center",
  gap: "10px",
};

export const MarketingHeader: React.FC<MarketingHeaderProps> = ({
  onLogin,
}) => {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 860);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  return (
    <header
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: isMobile ? "20px" : "20px 60px",
        maxWidth: "1200px",
        margin: "0 auto",
      }}
    >
      <Link
        to="/"
        style={{
          textDecoration: "none",
          color: TEXT,
          fontSize: "20px",
          fontWeight: 700,
          letterSpacing: "-0.5px",
          ...gradientText,
        }}
      >
        HAL 8580
      </Link>
      <nav
        style={{
          display: "flex",
          alignItems: "center",
          gap: isMobile ? "16px" : "32px",
          fontSize: "14px",
        }}
      >
        {!isMobile && (
          <>
            <a
              href="/#features"
              style={{ color: MUTED, textDecoration: "none" }}
            >
              Features
            </a>
            <a href="/#how" style={{ color: MUTED, textDecoration: "none" }}>
              How it works
            </a>
            <Link to="/faq" style={{ color: MUTED, textDecoration: "none" }}>
              FAQ
            </Link>
          </>
        )}
        <button onClick={onLogin} style={primaryButton}>
          <Icon name="gamepad-2" size={18} color="white" />
          Log in
        </button>
      </nav>
    </header>
  );
};
